import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsSessionValid } from '../store/slices/authSlice';

/**
 * Layout route for the signed-OUT pages — sign-in and sign-up. An already
 * authenticated user landing here is bounced to the dashboard, so a bookmarked
 * /sign-in doesn't show a login form to someone who is already logged in.
 *
 * Note this is narrower than "a page anyone can see": /p/:accountId is public
 * to everyone including signed-in users, so it sits outside both guards.
 */
export default function PublicRoute() {
  const isSignedIn = useSelector(selectIsSessionValid);

  if (isSignedIn) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
}
